import { Api } from 'lib';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { EntitySettings, IrreversableModal } from 'screens/Admin/components';

const Settings = ({ game, loading, setLoading, closePanel }) => {
  const [visible, setVisible] = useState(false),
    [showAlert, setShowAlert] = useState(false),
    [loading2, setLoading2] = useState(null),
    dispatch = useDispatch();

  const settings = [
    {
      text: 'Remove game',
      icon: 'delete',
      onClick: () => setShowAlert(true),
      isDisabled: loading2 === 'remove'
    }
  ];

  async function remove() {
    setLoading(true);
    setLoading2('remove');

    const res = await Api.post('/admin/removeData', { type: 'game', id: game._id });
    if (!res) return;

    dispatch({
      type: 'ADMIN_REMOVE_DATA',
      payload: game._id
    });

    setVisible(false);
    setLoading(false);
    setLoading2(null);
    closePanel();
  }

  return (
    <React.Fragment>
      <EntitySettings col="#fff" options={settings} />

      <IrreversableModal
        visible={showAlert}
        onConfirm={remove}
        closeModal={() => setShowAlert(false)}
        text="Are you sure you want to remove this game?"
        heading="This action is irreversable."
      />
    </React.Fragment>
  );
};

export default Settings;
